export const data = [
    {
        type: "info",
        text: "Willkommen",
        // a wild bee and a honey bee
        githubLinkText: "Open Source - QuellCode auf GitHub",
    },
    // wild bee text here
    {
        type: "info",
        text: "*Honigbienen* werden seit mehreren Tausend Jahren vom Menschen gezüchtet",
        backgroundImage: "beekeeping.jpg",
    },
    {
        type: "info",
        text: "*Wildbienen* hingegen leben meistens als Einzelgänger",
        backgroundImage: "purpleflower.jpg",
    },
    // Why bees are important
    {
        type: "info",
        text: "Fast 80% aller Nutz- und Wildpflanzen, darunter auch *Obst* und *Gemüse* wie Birnen, Äpfel, Kirschen, Erdbeeren, Pflaumen, Beeren, Pfirsiche, Nektarinen oder Trauben werden von Bienen bestäubt",
        backgroundImage: "ricefruits.jpg",
    },
    {
        type: "info",
        text: "Aber auch die Verfügbarkeit von z.B. Nüssen oder Raps, haben wir der Bestäubung durch die Biene zu verdanken",
        backgroundImage: "golden-rod.jpg",
    },
    {
        type: "info",
        text: "Sie ist deswegen das drittwichtigste Nutztier nach Rind und Schwein",
        backgroundImage: "orange_bee.jpg",
    },
    // {
    //   type: "info",
    //   text: "Wildbienen bestäuben Blüten deutlich effizienter als Honigbienen und leisten damit einen wichtigen Beitrag zur Sicherung der Erträge",
    // },
    // {
    //   type: "info",
    //   text: "Aber auch die Pflanzenwelt würde sich drastisch ändern, denn ohne Bienen würden viele Arten nicht bestäubt werden und die Vielfalt würde verloren gehen",
    // },
    // {
    //   type: "info",
    //   text: "Das wiederum hätte Auswirkungen auf die Tierwelt à für beispielsweise Vögel, Frösche, Fische oder Fledermäuse, da viele Insekten, eben auch die Biene, als Nahrungsgrundlagen für diese Tiere dienen"
    // }
    // bienensterben hier
    {
        type: "info",
        text: "Aber der Bestand an Bienen, geht immer mehr zurück",
        backgroundImage: "deadbee.jpg",
    },
    {
        type: "info",
        text: "In manchen teilen der Chinas gibt es heute schon gar keine Bienen mehr",
        backgroundImage: "deadbees.jpg",
    },
    {
        type: "info",
        text: "Dort müssen Wanderarbeiter Blumen von Hand bestäuben",
        backgroundImage: "hand-pollination.jpg",
    },
    {
        type: "info",
        text: "In Deutschland gibt es 590 Wildbienenarten, davon sind über *50% bedroht* und *30% vom Aussterben* bedroht",
        backgroundImage: "concrete.jpg",
    },
    {
        type: "info",
        text: "Insgesamt gibt es heute 80% weniger Insekten als vor 30 Jahren",
    },
    // Wildbienen
    // {
    //   type: "info",
    //   text: "Es fehlen natürliche Lebensräume für Wildbienen in Form von vielfältigen Blütenwiesen, Hecken, Wiesengehölzer, Unkraut, laubbedeckte Gärten, Holznistplätze, morschen Baumästen, Biotopen",
    //   backgroundImage: "biotope.jpg"
    // },
    // {
    //   type: "info",
    //   text: "Das Finden von geeigneten Nistplätzen ist dadurch sehr schwierig für die Bienen",
    //   backgroundImage: "red-forest.jpg"
    // },
    {
        type: "info",
        text: "Die Hälfte der Wildbienen wohnen unter der Erde, entweder in den Gängen anderer Insekten, in selbstgebauten Niströhren, hohlen Pflanzenstängeln oder in Mauerspalten",
        backgroundImage: "biotope.jpg",
    },
    {
        type: "info",
        text: "Wildbienen leben nur etwa vier bis sechs Wochen",
        backgroundImage: "purpleflower.jpg",
    },
    {
        type: "info",
        text: "Auch die Hummel gehört zu den Wildbienen",
        backgroundImage: "bumblebee.jpg",
    },
    // Honigbienen
    {
        type: "info",
        backgroundImage: "bee-colony.jpg",
        text: "Honigbienen hingegen leben in einem Bienenvolk, das aus ca. 60.000 Arbeitsbienen besteht, einigen Hundert Drohnen und einer Königin",
    },
    {
        type: "info",
        backgroundImage: "beekeeping.jpg",
        text: "Sie werden seit mehreren Tausend Jahren vom Menschen gezüchtet",
    },
    // die probleme
    // {
    //   type: "info",
    //   text: "Aber es gibt viele Probleme..."
    // }
    // {
    //   type: "info",
    //   text: "Das Blütenangebot fehlt, durch intensive Landwirtschaft und Monokulturen",
    // },
    // {
    //   type: "info",
    //   text: "Nach dem Frühjahr werden viele Wildblumen abgemäht und die Felder sind verblüht, somit sind die nötigen Ressourcen für eine optimalen Entwicklung von Wild- und Honigbiene nicht vorhanden",
    // },
    // {
    //   type: "info",
    //   text: "Aufgrund des Nahrungsmangels sind die Tiere entweder geschwächt oder gestresst und können sich nicht mehr vermehren.",
    // },
    // {
    //   type: "info",
    //   text: "Ein weiteres Problem ist der Einsatz von Pestiziden und Chemikalien in der Landwirtschaft",
    // },
    // {
    //   type: "info",
    //   text: "Diese dringen in die Nahrungsquellen der Bienen oder die Bienen sind den Pestiziden direkt ausgesetzt",
    // },
    // {
    //   type: "info",
    //   text: "Sie beeinflussen das Nervensystem der Insekten und ihre natürliche Orientierungsfähigkeit und können ihre Lebensdauer und Fortpflanzung beeinträchtigen.",
    // },
    // {
    //   type: "info",
    //   text: "Die Auswirkungen können entweder sofort eintreten oder sich erst im Lauf der Zeit bemerkbar machen",
    // },
    {
        type: "info",
        text: "... und vieles mehr",
    },
    {
        type: "info",
        text: "Was kann man da tun?",
    },
    {
        type: "info",
        text: "Biete Nistmöglichkeiten für Wildbienen an",
    },
    {
        type: "info",
        text: "Es muss nicht gleich ein riesiges „Bienen- oder Insektenhotel“ sein, auch mit wenig Aufwand kannst Du unseren Freunden helfen",
    },
    // {
    //   type: "info",
    //   text: "",
    // },
    // {
    //   type: "info",
    //   text: "",
    // },
    // {
    //   type: "info",
    //   text: "",
    // },
    // {
    //   type: "info",
    //   text: "",
    // },
    // Übergang
    // Lösungen 1 2 3 4
    // game
    // email
    // thanks
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // {
    //   type: "info",
    //   backgroundImage: "orange_bee.jpg",
    //   text: "Honigbienen leben in einem Bienenvolk, das aus ca. 60.000 Arbeitsbienen besteht, einigen Hundert Drohnen und einer Königin",
    // },
    // {
    //   type: "info",
    //   backgroundImage: "orange_bee.jpg",
    //   text: "Sie werden seit mehreren Tausend Jahren vom Menschen gezüchtet",
    // },
    // {
    //   type: "info",
    //   backgroundImage: "purpleflower.jpg",
    //   text: "Wildbienen hingegen leben meistens als Einzelgänger, die meisten weiblichen Bienen leben allein und versorgen ihre Bruteier ohne Hilfe von Artgenossen",
    // },
    // {
    //   type: "info",
    //   backgroundImage: "purpleflower.jpg",
    //   text: "Fast 50% der Wildbienen nisten unter der Erde, entweder in den Gängen anderer Insekten, in selbstgebauten Niströhren, hohlen Pflanzenstängeln oder in Mauerspalten",
    // },
    // {
    //   type: "info",
    //   backgroundImage: "purpleflower.jpg",
    //   text: "Wildbienen leben nur etwa vier bis sechs Wochen. In dieser recht kurzen Lebensspanne schaffen es Weibchen maximal zehn bis 30 mit Pollen versorgte und befruchtete Brutzellen anzulegen",
    // },
    // {
    //   type: "info",
    //   backgroundImage: "purpleflower.jpg",
    //   text: "Auch die Hummel gehört zu den Wildbienen",
    // },
    {
        type: "quiz",
        backgroundImage: "orange_bee.jpg",
        question: "Wie groß sind Völker von Honigbienen in der Regel?",
        answers: [
            {
                answer: "ca. 100 Bienen",
                correct: false,
            },
            {
                answer: "mehr als 50.000 Bienen",
                correct: true,
            },
            {
                answer: "ca 1 Million Bienen",
                correct: false,
            },
        ],
    },
    {
        type: "quiz",
        backgroundImage: "bumblebee.jpg",
        question: "Die Hummel ist...",
        answers: [
            {
                answer: "eine Honigbiene",
                correct: false,
            },
            {
                answer: "eine Wildbiene",
                correct: true,
            },
        ],
    },
    {
        type: "game",
        title1: "Spiele Tic Tac Toe in wabenform",
        title2: "bitte zu zweit spielen",
        next: "spiel beenden >",
        backgroundImage: "sungarden.jpg",
    },
    {
        type: "email",
        mainText: "Bleibe informiert, trage Deine Email-Adresse ein: ",
        emailPlaceholderText: "deine email hier...",
        buttonText: "Senden",
        thanksText: "Vielen Dank für Dein Vertrauen!",
    },
    {
        type: "info",
        text: "Ende",
        githubLinkText: "Open Source - QuellCode auf GitHub",
    },
];
